import React from 'react';

import { Panel } from '@myhealth-raccoon/components';

import { ClinicBillingPolicy } from './ClinicBillingPolicy';
import { PricingDetails } from './PricingDetails';
import { CancellationPolicyNotice } from 'src/components/CancellationPolicyNotice.tsx';
import { useAppointmentTypeSelector, useClinicSelector } from 'src/hooks/useAsyncSelector';
import { isAfterHours } from 'src/utils/appointmentTypes';

type Props = {
    isOpen: boolean;
    setOpen(open: boolean): void;
};
export function CancellationPolicyDrawer({ isOpen, setOpen }: Props) {
    const { data: clinic } = useClinicSelector();
    const { data: appointmentType } = useAppointmentTypeSelector();

    return (
        <Panel
            attachedTo="bottom"
            open={isOpen}
            setOpen={setOpen}
            title={<h2 className="px-2 py-3 text-lg font-semibold text-gray-900">Pricing and Cancellation Info</h2>}
        >
            <hr />
            {appointmentType && isAfterHours(appointmentType) ? (
                <div className="p-4 text-sm">
                    <PricingDetails appointmentType={appointmentType} />
                    <hr className="my-4" />
                    This is a private service. You will not receive any Medicare Rebates for this consultation.
                </div>
            ) : (
                clinic && (
                    <>
                        <div className="p-4 text-sm">
                            <h3 className="mb-1 text-base font-semibold text-gray-900">Pricing details</h3>
                            <ClinicBillingPolicy clinic={clinic} />
                        </div>
                        {clinic.cancellationPolicyHtml && (
                            <>
                                <hr />
                                <CancellationPolicyNotice
                                    html={clinic.cancellationPolicyHtml}
                                    appointmentType={appointmentType}
                                    className="p-4"
                                />
                            </>
                        )}
                    </>
                )
            )}
        </Panel>
    );
}
